import React from 'react'
import { EffectComposer, Autofocus } from '@react-three/postprocessing'
import { CameraControls, Html } from '@react-three/drei'
import { useRef, useEffect } from 'react'
import { useThree } from '@react-three/fiber'
import useGame from './stores/useGame'
import { Leva, useControls } from 'leva'


export default function PointsCameraSystem(props)
{
    const meshRef = useRef()
    const cameraControlsRef = useRef()
    const useMesh = props.model
    const renderState = useThree()
    const efRef = useRef()
    const dofRef = useRef()

    const { camera } = useThree()

    const {...efConfig} = useControls('PostProcessing',{
        enabled: true
    })

    


    const {...dofConfig} = useControls('DOF',{
        focalLength: {value: 0.05, min: 0.00, max: 0.50, step: 0.01},
        bokehScale: {value: 4.0, min: 0.0, max: 5.0, step: 0.1}
    })

    var fogConfig = [0xf3fcff, 50, 200]

    if(renderState.size.width < 900)
        {
            efConfig.enabled = false
        }

    
    const Points = (props) =>
        {

            const phase = useGame((state) => state.phase)

            return  <>

                    <mesh ref={meshRef} position={props.target}>

                        <Html wrapperClass='point' > 

                        { phase === 'rest' &&  <>
                            <div className="pulse" onClick={()=> MoveCam(props.id, props.position, props.target)}></div>
                            <div className="label" onClick={()=> MoveCam(props.id, props.position, props.target)}>+</div> 
                            </>
                        }

                        { phase != 'rest' &&  
                            <div className="label-hidden"></div> 
                        }

                        </Html>

                    </mesh>

                    </>
        }

    const PointSpawn = () =>
    {
        const children = useMesh.props.children.props.children.props.children
                
        let points = []
        let targets = []

        let interactions = []

        children.forEach(function(child) {
            var name = child.props.name


            if(name.includes('CP')){
                points.push(child.props.position)}

            if(name.includes('CT')){
                targets.push(child.props.position)}
     
            })

        for (let i = 0; i < points.length; ++i)
        {
            interactions.push(<Points key={i} id={[i]} position={points[i]} target={targets[i]}/>)
        }

        return(interactions)
    }

    const phase = useGame((state) => state.phase)
    const infoPanel = useGame((state) => state.infoPanel)
    const move = useGame((state) => state.move)

    const p0 = useGame((state) => state.p0)
    const p1 = useGame((state) => state.p1)
    const p2 = useGame((state) => state.p2)

    const MoveCam = (id, position, target) =>
    {    
        

        if(id[0] == '0')
            {
                p0()
            }


        if(id[0] == '1')
            {
                p1()
            }

        if(id[0] == '2')
            {
                p2()
            }

        cameraControlsRef.current.setLookAt(...position, ...target, true)



        move()
    }
    
    

    useEffect(() => {

        if (phase === 'rest')
            {   
                cameraControlsRef.current.reset(true)
                cameraControlsRef.current.truckSpeed = 0
                cameraControlsRef.current.dollySpeed = 0
                

                
                if(renderState.size.width < 480)
                    {
                        
                        cameraControlsRef.current.zoom(-0.6, true)          
                        efConfig.enabled = false
                    }


            }   

    }, [phase, renderState.size.width])

    useEffect(() => {
       
        if (phase === 'move')
            {   
                
                if(renderState.size.width < 480)
                    {       
                        cameraControlsRef?.current.setTarget(cameraControlsRef.current?._targetEnd.x, cameraControlsRef.current?._targetEnd.y - 5 ,cameraControlsRef.current?._targetEnd.z, true)
                    }


            }   

    }, [phase])

    

    return(
        <>
        <fog attach="fog" args={fogConfig} />
        <color attach="background" args={[0xf3fcff]} />

        <Leva hidden={true} />
            <CameraControls 
                ref={cameraControlsRef}
                polarRotateSpeed={0}
                truckSpeed={0}
                dollySpeed={0}
                
                />
            <PointSpawn/>

            <EffectComposer ref={efRef} {...efConfig}>
            
                <Autofocus
                ref={dofRef}
                width={1024}
                height={1024}
                {...dofConfig}

                />
               
            </EffectComposer>
        </>
    )

}